const houseSvg = (
  <svg
    className="panelIcon ucInfo-calendar"
    xmlns="http://www.w3.org/2000/svg"
    height="48"
    viewBox="0 -960 960 960"
    width="48"
  >
    <path d="M189-149v-320H50l430-386 189 166v-102h102v197l139 124.574H771V-149H571v-234H389v234H189Zm200-402h182q0-36-26.857-60.5t-64-24.5Q443-636 416-611.658 389-587.315 389-551Z" />
  </svg>
);

export default houseSvg;
